import { render, staticRenderFns } from "./staffHealthQueAns.vue?vue&type=template&id=51f5c13c"
import script from "./staffHealthQueAns.vue?vue&type=script&lang=js"
export * from "./staffHealthQueAns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports